import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
// Split on literal newlines or <br> tags emitted by captionParser when joining
// multi-line cues. Render each segment as plain text so the cue payload cannot
// inject HTML.
const LINE_BREAK = /<br\s*\/?>|\r?\n/i;
export const CaptionOverlay = React.memo(function CaptionOverlay({ text }) {
    if (!text)
        return null;
    const lines = text.split(LINE_BREAK);
    return (_jsx("div", { className: "hekate-player-caption-container", children: _jsx("div", { className: "hekate-player-caption-overlay", "aria-live": "polite", "aria-atomic": "true", children: lines.map((line, i) => (_jsxs(React.Fragment, { children: [i > 0 && _jsx("br", {}), line] }, i))) }) }));
});
